import React, { useEffect, useState } from "react";
import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import packkagee from "../package.json";
// import Routes from "./Routes";
import { ThemeProvider, defaultTheme, mergeTheme } from "evergreen-ui";
import { MDBCol, MDBContainer, MDBRow } from "mdbreact";
import HeadersPresent from "./Components/HeadersPresent";
import Headers from "./Components/Headers";
import { Route, Switch } from "react-router-dom";
import Home_newlastbee from "./Pages/Home_newlastbee";
import Home from "./Pages/Home";
import News from "./Pages/news";
import Publishregister from "./Pages/publishregister";
import Publishinterview from "./Pages/publishinterview";
import Publishpresent from "./Pages/publishpresent";
import Calendars from "./Pages/calendars";
import Procedureregister from "./Pages/procedureregister";
import Procedurepresent from "./Pages/procedurepresent";
import Scholarship from "./Pages/scholarship";
import Register_new from "./Pages/register_new";
import RegisterNormall from "./Pages/SelectRegister/RegisterNormall";
import Checkvutregister from "./Pages/checkvut/checkvutregister";
import CheckVutMaster from "./Pages/checkvut/CheckVutMaster";
import CheckVutDoctory from "./Pages/checkvut/CheckVutDoctor";
import Formprofile from "./Pages/formregister/formprofile";
import FormProfileNewBee from "./Pages/formregister/FormProfileNewBee";
import Formregister from "./Pages/formregister/formregister";
import FormRegisterB from "./Pages/formregister/FormRegisterB";
import FormRegistNurse from "./Pages/formregister/FormRegistNurse";
import FormRegisterBandit from "./Pages/formregister/FormRegisterBandit";
import FormRegisterMaster from "./Pages/formregister/FormRegisterMaster";
import Checkregister from "./Pages/checkregister";
import DataRegister2025 from "./Pages/DataRegister2025";
import NewDataRegister from "./Pages/NewDataRegister";
import Tuitionfees from "./Pages/Tuitionfees";
import Tuitionfee from "./Pages/tuitionfee";
import Page1 from "./Pages/calendar/page1";
import Page1_nurse from "./Pages/calendar/page1_nurse";
import TestInput from "./Pages/publish/TestInput";
import Page2 from "./Pages/calendar/page2";
import Page5 from "./Pages/calendar/page5";
import Checkpresent from "./Pages/checkpresent";
import CheckPresentNew from "./Pages/CheckPresentNew";
import Present from "./Pages/formpresent/present";
import Insertpresent1 from "./Pages/formpresent/insertpresent1";
import Insertpresent2 from "./Pages/formpresent/insertpresent2";
import Insertpresent3 from "./Pages/formpresent/insertpresent3";
import Insertpresent4 from "./Pages/formpresent/insertpresent4";
import Insertpresent5 from "./Pages/formpresent/insertpresent5";
import Insertpresent6 from "./Pages/formpresent/insertpresent6";
import Insertpresent7 from "./Pages/formpresent/insertpresent7";
import Insertpresent8 from "./Pages/formpresent/insertpresent8";
import Insertpresent9 from "./Pages/formpresent/insertpresent9";
import Insertpresent10 from "./Pages/formpresent/insertpresent10";
import WaiverForm from "./Pages/formpresent/waiver_form";
import TestUpload from "./Pages/formregister/TestUpload";
import Select_bundit from "./Pages/select_bundit";
import register_doctorate from "./Pages/register_doctorate";
import register_master from "./Pages/register_master";
import Register1 from "./Pages/registerbundit";
import Registerbundit2 from "./Pages/registerbundit2";
import Footer from "./Components/Footer";
import checkcrackcresent from "./Pages/checkcrackpresent";
import RegisterPage2026 from "./Pages/RegisterPage2026";
function App() {
  useEffect(() => {
    // if (n
    //   window.location.pathname.includes("admission2024/Checkcrackpresent") ||
    //   window.location.pathname.includes("admission2024/checkcrackpresent")
    // ) {
    //   const paths = window.location.pathname.split("/");
    //   window.location.href =
    //     "https://admission.kpru.ac.th/admission/" + paths[2] + "/" + paths[3];
    //   console.log("พบคำว่า admission2024 ใน URL");
    // } else {
    //   window.location.href = "https://admission.kpru.ac.th/admission/";
    // }
  }, []);
  const theme = mergeTheme(defaultTheme, {
    Button: {
      appearances: {
        views: {
          color: "white",
          paddingX: 12,
          paddingY: 8,
          borderRadius: 5,
          backgroundColor: "#FFB020",
          selectors: {
            _hover: {
              backgroundColor: "#996A13",
            },
            _active: {
              backgroundColor: "#996A13",
            },
            _focus: {
              boxShadow: "0 0 0 2px lightcoral",
            },
          },
        },
      },
    },
  });
  return (
    <>
      <ThemeProvider value={theme}>
        <MDBContainer fluid>
          {window.location.pathname === "/" ||
          window.location.pathname === "/" + packkagee.name ||
          window.location.pathname === "/" + packkagee.name + "/" ? (
            <></>
          ) : (
            <>
              {localStorage.getItem("statusHeader") === "1" ? (
                <>
                  {/* <Switch> */}
                  <HeadersPresent />
                  {/* </Switch> */}
                </>
              ) : (
                <>
                  {/* <Switch> */}
                  <Headers />
                  {/* </Switch> */}
                </>
              )}
            </>
          )}
          <MDBRow className="p-0">
            <MDBCol className="p-0">
              <Switch>
                <Route exact path="/" component={Home_newlastbee} className="m-0" />
                {/* <Route exact path="/" component={RegisterPage2026} className="m-0" /> */}
                <Route path="/main" component={Home} />
                <Route path="/News/:param" component={News} />
                <Route path="/Publishregister" component={Publishregister} />
                <Route path="/Publishinterview" component={Publishinterview} />
                <Route path="/Publishpresent" component={Publishpresent} />
                <Route path="/Calendars" component={Calendars} />
                <Route path="/Procedureregister" component={Procedureregister} />
                <Route path="/Procedurepresent" component={Procedurepresent} />
                <Route path="/Scholarship" component={Scholarship} />
                {/* <Route  path="/Register/:param" component={Register} /> */}
                <Route path="/Register/:param" component={Register_new} />
                <Route path="/RegisterNormall" component={RegisterNormall} />

                <Route path="/Checkvutregister" component={Checkvutregister} />
                <Route path="/Checkvutregister-master" component={CheckVutMaster} />
                <Route path="/Checkvutregister-doctor" component={CheckVutDoctory} />
                <Route path="/Formprofile2xx" component={Formprofile} />
                <Route path="/Formprofile" component={FormProfileNewBee} />
                <Route path="/Formregister" component={Formregister} />
                {/* <Route  path="/Formregister" component={Formregister} /> */}
                <Route path="/Formregisters" component={FormRegisterB} />
                <Route path="/FormregistNurse" component={FormRegistNurse} />
                <Route path="/Formregister-bundit" component={FormRegisterBandit} />
                <Route path="/Formregister-master" component={FormRegisterMaster} />
                {/* <Route  path="/FormProfileMaster" component={FormProfileMaster} /> */}
                <Route path="/Checkregister/:param" component={Checkregister} />
                <Route path="/Dataregister" component={DataRegister2025} />
                <Route path="/DataregisterOld" component={NewDataRegister} />
                <Route path="/Tuitionfee" component={Tuitionfees} />
                <Route path="/uitionfee" component={Tuitionfee} />
                <Route path="/calendar/Page1" component={Page1} />
                <Route path="/calendar/Page1_nurse" component={Page1_nurse} />
                <Route path="/tttt" component={TestInput} />
                <Route path="/calendar/Page2" component={Page2} />
                <Route path="/calendar/Page5" component={Page5} />

                <Route path="/Checkpresent/:param" component={Checkpresent} />
                <Route path="/Checkpresent" component={Checkpresent} />
                <Route path="/checkcrackpresent/:id" component={checkcrackcresent} />
                {/* <Route  path="/Checkpresent" component={Checkpresent} /> */}
                {/* <Route  path="/Checkpresent" component={CheckPresent2025} /> */}
                <Route path="/Checkpresent2" component={CheckPresentNew} />
                <Route path="/Present" component={Present} />
                {/* <Route  path="/Presents" component={Present2025} /> */}

                <Route path="/Insertpresent1" component={Insertpresent1} />
                <Route path="/Insertpresent2" component={Insertpresent2} />
                {/* <Route  path="/Insertpresent2new" component={InsertPresent2New} /> */}
                <Route path="/Insertpresent3" component={Insertpresent3} />
                <Route path="/Insertpresent4" component={Insertpresent4} />
                <Route path="/Insertpresent5" component={Insertpresent5} />
                <Route path="/Insertpresent6" component={Insertpresent6} />
                <Route path="/Insertpresent7" component={Insertpresent7} />
                <Route path="/Insertpresent8" component={Insertpresent8} />
                <Route path="/Insertpresent9" component={Insertpresent9} />
                <Route path="/Insertpresent10" component={Insertpresent10} />

                {/* <Route path="/Checkcrackpresent/:id" component={Checkcrackpresent} /> */}
                <Route path="/waiver" component={WaiverForm} />
                <Route path="/testupload" component={TestUpload} />
                <Route path="/select-bundit" component={Select_bundit} />
                <Route path="/bundit_1" component={register_doctorate} />
                <Route path="/bundit_2" component={register_master} />
                <Route path="/form-doctorate" component={Register1} />
                <Route path="/form-master" component={Registerbundit2} />
              </Switch>
              <br />
            </MDBCol>
          </MDBRow>
          {window.location.pathname === "/" ||
          window.location.pathname === "/" + packkagee.name ||
          window.location.pathname === "/" + packkagee.name + "/" ? (
            <></>
          ) : (
            <>
              <Footer />
            </>
          )}
        </MDBContainer>
      </ThemeProvider>
    </>
  );
}
export default App;
